import { useEffect } from 'react';

export default function ConfirmModal({
    title, body, confirmLabel = 'Confirm', cancelLabel = 'Cancel',
    isDestructive = false, onConfirm, onCancel,
}) {
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onCancel]);

    return (
        <div className='modal-backdrop' onClick={e => { if (e.target === e.currentTarget) onCancel(); }}>
            <div className='modal' role='dialog' aria-modal='true'>
                <h2 className='modal-title'>{title}</h2>
                <div className='modal-body'>{body}</div>
                <div className='modal-actions'>
                    <button className='user-cancel-btn' onClick={onCancel}>{cancelLabel}</button>
                    <button
                        className={isDestructive ? 'batch-action-btn danger' : 'user-submit-btn'}
                        onClick={onConfirm}
                        autoFocus
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}